var _circle, _path, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataShopping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.186 68.7943H79.4V71.1943H41.8C39.2161 71.1943 37.2 69.1522 37.2 66.7943C37.2 66.0291 37.4026 65.324 37.7481 64.7377L37.7561 64.7241L37.7639 64.7104L42.2189 56.8704L42.7406 55.9522L42.2766 55.0036L30.3966 30.7156L29.8482 29.5943H28.6H24V27.1943H31.5378L34.0933 32.4666L34.6398 33.5943H35.893H84.6972C84.9347 33.5951 85.1647 33.6557 85.3642 33.7661C85.564 33.8765 85.7233 34.0312 85.8323 34.209C85.9411 34.3864 85.9979 34.5832 86.002 34.7805C86.0061 34.9757 85.9588 35.1718 85.8603 35.3507L74.0516 56.1094L74.0491 56.1138C73.2864 57.4625 71.7781 58.3943 70.015 58.3943H45.43H44.2673L43.692 59.4047L40.722 64.6207L40.59 64.8526L40.5233 65.111L40.4243 65.495L40.361 65.7407V65.9943C40.361 67.6045 41.6779 68.7943 43.186 68.7943Z",
    stroke: "#222222",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 83.333,
    r: 7,
    fill: "#6484F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 83.333,
    r: 7,
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataShopping);
export default __webpack_public_path__ + "static/media/data-shopping.b0161f0efd517b8bd7d5f0a8bbc47355.svg";
export { ForwardRef as ReactComponent };